<template>
  <div v-if="visible" class="container-loading">
    <div class="loader">
      <div class="inner one"></div>
      <div class="inner two"></div>
      <div class="inner three"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "loader",
  props: ["visible"],
};
</script>
<style lang="scss" scoped>
.container-loading {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 10000000000000000000 !important;
  background-color: darkgrey;
  opacity: 0.5;
}
.loader {
  position: absolute;
  top: calc(50% - 32px);
  //  top: 420px;
  left: calc(50% - 32px);
  width: 104px;
  height: 104px;
  border-radius: 50%;
  perspective: 800px;
}

.inner {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.inner.one {
  left: 0%;
  top: 0%;
  animation: rotate-one 1s linear infinite;
  border-bottom: 8px solid #ffffff;
}

.inner.two {
  right: 0%;
  top: 0%;
  animation: rotate-two 1.1s linear infinite;
  border-right: 8px solid #005856;
}

.inner.three {
  right: 0%;
  bottom: 0%;
  animation: rotate-three 1.1s linear infinite;
  border-top: 8px solid #007470;
}

@keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}
</style>
